import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store'
import axios from '@/assets/js/axiosExtend.js'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
// import i18n from '@/assets/lang/index'
// import '@/assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.css'
import '@/theme/index.css';
import '@/assets/css/index.less';
import '@/assets/css/common.less';
Vue.config.productionTip = false
Vue.use(VueAxios,axios);
Vue.use(ElementUI,{
    // i18n : (key,val)=>i18n.t(key,val) // 用于elementUI插件的中英文翻译
});
new Vue({
    // i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app')
